<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="smsapies"
      :page.sync="currentPage"
      :search="search"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({})" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
      <template v-slot:item.settings="{item}"><span>{{JSON.stringify(item.settings)}}</span></template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>{{$t("admin.smsapi")}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field v-model="item.name" :label="$t('fields.name')"></v-text-field>
            <v-text-field
              v-for="(v,k) in item.settings"
              :key="k"
              :label="k"
              clearable
              @click:clear="rem(k)"
              v-model="item.settings[k]"
            ></v-text-field>
            <v-row>
              <v-col>
                <v-text-field v-model="newkey" @change="add"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="newval" @change="add"></v-text-field>
              </v-col>
            </v-row>
            <div>{{JSON.stringify(item.settings)}}</div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="remove" color="primary">{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
export default {
  name: "SmsApi",
  mixins: [commonmixin],
  data() {
    return {
      newkey: "",
      newval: "",
      d_edit: false,
      item: { settings: {} },
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 100,
          sorted: false
        },
        {
          text: this.$t("fields.name"),
          value: "name"
        },
        {
          text: this.$t("fields.created"),
          value: "created"
        },
        {
          text: this.$t("fields.updated"),
          value: "updated"
        },
        {
          text: this.$t("fields.settings"),
          value: "settings",
          sorted: false,
          width: 300
        }
      ]
    };
  },
  methods: {
    add() {
      this.item.settings = {
        ...this.item.settings,
        [this.newkey]: this.newval
      };
    },
    rem(k) {
      console.log(k);
      this.$delete(this.item.settings, k);
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      //      this.item.settings = JSON.stringify(this.item.settings);
      this.currentIdx = this.smsapies.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_SMSAPI", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      try {
        //      this.item.settings = JSON.parse(this.item.settings);
        if (this.item.idx) {
          this.$store
            .dispatch("admin/UPDATE_SMSAPI", {
              item: this.item,
              index: this.currentIdx
            })
            .then(() => {
              this.d_edit = false;
            });
        } else {
          this.$store.dispatch("admin/INSERT_SMSAPI", this.item).then(() => {
            this.d_edit = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    smsapies() {
      return this.$store.getters["admin/smsapies"];
    }
  },
  mounted() {
    if (!this.$store.getters["admin/isSmsapies"]) {
      this.$store.dispatch("admin/LOAD_SMSAPIES");
    }
  }
};
</script>

<style>
</style>